import { SimplifiedTableComponent } from './simplified-table/simplified-table.component';

export * from './simplified-table/simplified-table.component';

export const simplifiedTableExports = [SimplifiedTableComponent];

export const simplifiedTableDeclarations = [...simplifiedTableExports];
